<template>
  <div class="vlog-card">
    <div class="vlog-card__content">
      <div class="vlog-card__pill-container">
        <span class="vlog-card__pill">{{ seasonPillContent }}</span>
        <span class="vlog-card__pill">{{ episodePillContent }}</span>
      </div>
      <h4 class="vlog-card__title">{{ vlog.name }}</h4>
      <a :href="ytLink" target="_blank" class="vlog-card__link">
        {{ $t('common.vlogs.watch') }}
      </a>
    </div>
    <BaseNuxtImage class="vlog-card__image" :src="imgSrc" :alt="imgAlt" />
  </div>
</template>

<script setup lang="ts">
interface Props {
  vlog: any
}

const { t } = useI18n()
const props = defineProps<Props>()

const imgSrc = computed(() => {
  return props.vlog?.content?.image?.filename || ''
})

const ytLink = computed(() => {
  return props.vlog?.content?.youtube_link || ''
})

const imgAlt = computed(() => {
  return props?.vlog.content?.image?.alt || ''
})

const seasonPillContent = computed(() => {
  return (props?.vlog?.content?.season || '') + ' ' + t('common.vlogs.season')
})

const episodePillContent = computed(() => {
  return (
    (props.vlog?.content?.episode_number || '') +
    ' ' +
    t('common.vlogs.episode')
  )
})
</script>

<style lang="scss" scoped>
.vlog-card {
  background-color: white;
  border-radius: 20px;
  position: relative;

  &__content {
    padding: 40px;
    max-width: 360px;

    @media (min-width: $breakpoint-lg) {
      padding: 64px 48px;
    }
  }

  &__pill-container {
    display: flex;
    gap: 10px;
    margin-bottom: 32px;
  }

  &__pill {
    padding: 4px 12px;
    font-size: var(--font-size-paragraph-2xs);
    line-height: 16px;
    background-color: var(--paper-100);
    border-radius: 8px;
    font-weight: 600;
    text-transform: uppercase;
  }

  &__image {
    position: relative;

    @media (min-width: $breakpoint-lg) {
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
}
</style>
